import React, { Component } from "react";
import { Link } from "react-router-dom";

class BigButton extends Component {
    render() {
        return (
            <Link to={this.props.linkTo} className={"bigButton " + this.props.className}>
                {!!this.props.icon && <img src={this.props.icon} alt="-" />}
                {this.props.children}
            </Link>
        );
    }
}

export default BigButton;
